import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';
import { VARIANT } from '@motorway/mw-highway-code/enums';
import { MotorwayLogoWordmarkIcon } from '@THC/components/Icons/MotorwayLogoWordmark';

import { SP_HEADER_EVENTS } from 'Utilities/analytics/analyticsHeader';
import { useIsEmbeddedView } from 'Utilities/hooks/useIsEmbeddedView';

import { Content } from 'LegacySBCRA/Content/Content';

import { AccountLinks } from './AccountLinks';
import { HeaderBackground } from './HeaderBackground';
import { HeaderLinks } from './HeaderLinks';
import LocalTexts from './HeaderTexts.json';

import styles from './Header.scss';

const LocalT = new MDText(LocalTexts);
const t = (key: string) => LocalT.translate(key) as string;

export const Header = () => {
  const isEmbeddedView = useIsEmbeddedView();

  if (isEmbeddedView) {
    return null;
  }

  return (
    <>
      <HeaderBackground />
      <header className={styles.header} id="app-header">
        <Content className={cx(styles.header, styles.headerContent)}>
          <Hyperlink
            data-thc-link-logo
            aria-label={t('logoText')}
            as='a'
            href='/'
            label={<MotorwayLogoWordmarkIcon />}
            onClick={() => SP_HEADER_EVENTS.HEADER_LOGO_CLICKED()}
            variant={VARIANT.SECONDARY}
          />
          <div className={styles.menu}>
            <HeaderLinks />
            <AccountLinks />
          </div>
        </Content>
      </header>
    </>
  );
};
